import React from 'react';

import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';

import { formatCurrency } from '../../../../utils/currencyFormatter';

import commonAddServiceStyles from '../commonAdditionalService/commonAdditionalService.module.css';
import commonStyles from '../../../common/common.module.css';

const TEXT_FIELD_PADDINGS: string = '8px 12px';
const styles = (theme: any) => ({

});

interface PayByHouseBillProps {
  classes: any;
  serviceDetails: { cost_per_hawb_usd?: number, cost_per_kg_usd?: number };
};

const payByHouseBill = (props: PayByHouseBillProps) => {

  const { classes, serviceDetails } = props;

  return (
    <div className={ commonStyles.inputLabelWrapper } >
      <label className={ commonStyles.inputLabel }> Cost Per Unit  </label>
      <TextField
        className={ classes.a }
        disabled
        label=""
        defaultValue={ formatCurrency(serviceDetails.cost_per_hawb_usd ? serviceDetails.cost_per_hawb_usd : 0, 2, '$') + ' / HAWB' }
        variant="outlined"
        inputProps={{ style: { padding: TEXT_FIELD_PADDINGS } }}
        InputProps={{ classes: { notchedOutline: classes.overrideBorder } }}
        InputLabelProps={{ style: { fontWeight: 'bold' } }}
        fullWidth
      />
    </div>
  );
}

export default withStyles(styles)(payByHouseBill);